import { render, staticRenderFns } from "./ICUSurveillance.vue?vue&type=template&id=146c3011&"
import script from "./ICUSurveillance.vue?vue&type=script&lang=js&"
export * from "./ICUSurveillance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports